/**
 * Asset-class-aware routing utility.
 * Single source of truth for determining the correct detail page
 * for any financial instrument (stock, ETF, index, etc.).
 */

const ETF_PATTERNS = [
  /NAV$/i, /INAV$/i, /BEES$/i, /ETF$/i, /ETF\d/i, /CASE$/i,
  /^SETF/i, /^IVZIN/i, /^LICMF/i, /^EBBETF/i,
  /GOLDHALF$/i, /GOLDSHARE$/i, /LIQUID/i,
  /^QNIFTY/i, /^QGOLD/i, /^DSPN/i,
];

/**
 * Detect if a symbol is an ETF.
 * Uses a regex-based approach that mirrors the backend ETF_PATTERN.
 * Also accepts an optional `asset_class` hint from backend data.
 */
export function isETF(symbol, item = {}) {
  if (item?.asset_class === "etf" || item?.is_etf) return true;
  if (!symbol) return false;
  return ETF_PATTERNS.some((re) => re.test(symbol));
}

/**
 * Get the correct detail-page route for a symbol.
 * Returns '/stock/{symbol}' for equities, '/etf/{symbol}' for ETFs.
 */
export function getDetailRoute(symbol, item = {}) {
  if (!symbol) return "/";
  return isETF(symbol, item) ? `/etf/${symbol}` : `/stock/${symbol}`;
}
